import api from "./api";

export const getSettings = () => api.get("/settings").then((res) => res.data);

export const getGallery = () => api.get("/gallery").then((res) => res.data);

export const getTeam = () => api.get("/team").then((res) => res.data);

export const getTestimonials = () => api.get("/testimonials").then((res) => res.data);
